<template>
  <v-menu left light>
    <v-dialog v-model="showCriterio">
      <v-card color="#eaeaea" class="criterio-content">
        <CriterioDetail :criterio="currentCriterio"></CriterioDetail>
      </v-card>
    </v-dialog>
    <v-btn slot="activator" icon>
      <v-icon color="primary lighten-2">more_vert</v-icon>
    </v-btn>

    <v-list>
      <v-list-tile @click="fetchCriterio">
        <v-list-tile-title>Ver el criterio</v-list-tile-title>
      </v-list-tile>
      <v-list-tile @click="goPresentacion">
        <v-list-tile-title v-if="criterioComesFromActualizacion">Ir a la actualización</v-list-tile-title>
        <v-list-tile-title v-else>Ir a la presentación</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
import CriterioDetail from '../../presentacion/components/CriterioDetailTreeView'

export default {
  props: {
    criterio: Number,
    presentacion: Number,
    criterioComesFromActualizacion: Boolean
  },

  components: {
    CriterioDetail
  },

  data () {
    return {
      currentCriterio: {},
      showCriterio: false
    }
  },

  methods: {
    fetchCriterio () {
      this.axios
        .get(`criterio/${this.criterio}`)
        .then(response => {
          this.currentCriterio = response.data
          this.showCriterio = true
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    goPresentacion () {
      if (this.presentation !== -1) {
        if (this.criterioComesFromActualizacion) {
          this.$router.push({ name: 'actualizacion', params: { id: this.presentacion } })
        } else {
          this.$router.push({ name: 'presentacion', params: { id: this.presentacion } })
        }
      }
    }
  }
}
</script>

<style scoped>
  .criterio-content {
    padding: 0 1em 1em 1em;
  }
</style>
